export default __webpack_public_path__ + "static/koa-onion-model-d54becd68ab85ca57713f71e16e180eb.jpg";